// Image fallback (spec §5.2 step 4): favicon on a colored background derived
// from the title hash.
const PALETTE = [
  '#6366f1',
  '#0ea5e9',
  '#10b981',
  '#f59e0b',
  '#ef4444',
  '#8b5cf6',
  '#ec4899',
  '#14b8a6',
];

function hashColor(text: string): string {
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = (hash * 31 + text.charCodeAt(i)) | 0;
  }
  return PALETTE[Math.abs(hash) % PALETTE.length]!;
}

export default function Placeholder({
  title,
  faviconUrl,
  className,
}: {
  title: string;
  faviconUrl: string | null;
  className?: string;
}) {
  return (
    <div
      className={`flex items-center justify-center ${className ?? ''}`}
      style={{ backgroundColor: hashColor(title) }}
      aria-hidden
    >
      {faviconUrl ? (
        <img
          src={faviconUrl}
          alt=""
          referrerPolicy="no-referrer"
          loading="lazy"
          className="h-8 w-8 rounded"
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
      ) : (
        <span className="text-2xl font-bold text-white/80">{title.slice(0, 1).toUpperCase()}</span>
      )}
    </div>
  );
}
